module.exports = __webpack_public_path__ + "img/rackspace_logo.0cafbae9.png";